import { render, staticRenderFns } from "./lazadaprocessed.vue?vue&type=template&id=ebf44268&"
import script from "./lazadaprocessed.vue?vue&type=script&lang=js&"
export * from "./lazadaprocessed.vue?vue&type=script&lang=js&"
import style0 from "./lazadaprocessed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports